import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { Pagination, ConfigProvider } from 'antd';
import type { PaginationProps } from 'antd';

import { ReactComponent as ChevronLeft1 } from 'asserts/icons/ic_chevron_left.svg';
import { ReactComponent as ChevronRight1 } from 'asserts/icons/ic_chevron_right.svg';

interface Props {
  total: number;
  currentPage: number;
  pageSize?: number;
  onPageChange: (page: number) => void;
}
const Paginav = ({ total, onPageChange, currentPage, pageSize }: Props) => {
  const [page, setPage] = useState(currentPage);

  const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
    if (type === 'prev') {
      return <ChevronLeft1 />;
    }
    if (type === 'next') {
      return <ChevronRight1 />;
    }
    return originalElement;
  };

  const handlePageChange = (page: number) => {
    setPage(page);
    onPageChange && onPageChange(page - 1);
  };

  useEffect(() => {
    setPage(currentPage + 1);
  }, [currentPage]);

  return (
    <PaginavWrapper>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: color.opacityBlack05,
            borderRadius: 4,
            // Alias Token
            colorBgContainer: color.black2
          }
        }}
      >
        {/* {page > 1 && (
          <Chevron
            onClick={() => {
              setPage(1);
            }}
          >
            <ChevronLeft2 />
          </Chevron>
        )} */}

        <Pagination
          current={page}
          total={total}
          pageSize={pageSize}
          itemRender={itemRender}
          onChange={handlePageChange}
        />
        {/* {Math.round(total / 10) > page && (
          <Chevron onClick={() => setPage(total)}>
            <ChevronRight2 />
          </Chevron>
        )} */}
      </ConfigProvider>
    </PaginavWrapper>
  );
};

export default Paginav;

const PaginavWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .ant-pagination {
    display: flex;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    position: relative;
    line-height: 35px;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 14px;
    fill: ${color.black2};
  }

  & p {
    position: relative;
  }

  .ant-pagination-disabled {
    display: none;
  }

  .ant-pagination-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border-color: rgba(0, 0, 0, 0);
    a {
      ${font.caption1_medium};
      line-height: 26px;
    }
    &:hover {
      background-color: ${color.opacityBlack005};
      border: none;

      a {
        color: ${color.gray500};
      }
    }
  }
  .ant-pagination-item-active {
    a {
      color: ${color.white};
      font-weight: 500;
    }
  }
  .ant-pagination-options {
    display: none;
  }
`;

const Chevron = styled.p`
  cursor: pointer;
`;
